import { useTranslation } from "react-i18next";

import { PageError } from "@/modules/page-error";

import { BatchPreviewInterventionTransitionPage } from "../batch-preview-intervention-transition-page";
import { BatchPreviewObservationTransitionPage } from "../batch-preview-observation-transition-page";
import { BatchPreviewPageLayout } from "../batch-preview-page-layout";
import { useBatchPreviewTypeParam } from "../batch-preview.hook";

export const BatchPreviewPage = () => {
  const { t } = useTranslation();
  const typeParam = useBatchPreviewTypeParam();

  if (typeParam === "transition-intervention") {
    return <BatchPreviewInterventionTransitionPage />;
  }

  if (typeParam === "transition-observation") {
    return <BatchPreviewObservationTransitionPage />;
  }

  return (
    <BatchPreviewPageLayout
      title={t("global:batchPreview.defaultTitle")}
      error={<PageError status={404} />}
    />
  );
};
